import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  obtenerFormatoPrincipal(listado: any) {
    // obtengo el primer formato codigo de la lista
    let formatoPrincipal = listado && listado.length > 0 ? listado[0] : null;
    return formatoPrincipal;
  }
  obtenerFormatoSecundario(listado: any) {
    // obtengo el formato secundario del primer item de la lista
    let formatoSecundario = listado.length > 0 ? listado[0].formato_secundario : null;
    // si no existe formato secundario valido si trae mas items
    if (!formatoSecundario && listado.length > 1) {
      // tomo el primer item que le sigue al principal como formato secundario
      formatoSecundario = listado[1];
      return formatoSecundario;
    }
    // Valido que el formato secundario exista y que sea distinto al formato principal
    else if (formatoSecundario && formatoSecundario !== listado[0].formato_codigo) {
      formatoSecundario = listado.find(n => n.formato_codigo === formatoSecundario);
      return formatoSecundario;
    } else {
      return "";
    }
  }

  obtenerCantidadFormato(listado: any, formatoCodigo: string) {
    if (!listado || listado.length === 0) {
      return null;
    }

    // Buscar el formato exacto
    const formato = listado.find(item =>
      item.formato_codigo &&
      item.formato_codigo.toLowerCase() === formatoCodigo.toLowerCase()
    );

    if (formato) {
      // Si es Media X, extraer el número
      if (formato.formato_codigo.toLowerCase().startsWith('media')) {
        const match = formato.formato_codigo.match(/media\\s*(\\d+)/i);
        if (match) {
          return parseInt(match[1], 10);
        }
      }
      // Solo UNID devuelve 1, otros formatos usan su cantidad_formato
      if (formato.formato_codigo.toLowerCase() === 'unid') {
        return 1;
      }
      // Para todos los demás formatos, devolver la cantidad_formato
      return formato.cantidad_formato || 1;
    }

    // Si no encuentra, devolver null o 1 por defecto
    return 1;
  }

  esCaja(formatoCodigo: string, formatoCodigoTop: string): boolean {
    if (formatoCodigoTop === null) {
      return false;
    }

    if (formatoCodigoTop.toLowerCase().includes('unid')) {
      return false;
    }

    return formatoCodigo == formatoCodigoTop;
    // if (!formatoCodigo) return false;
    // const code = formatoCodigo.toLowerCase();

    // // Verificar formatos tradicionales (ca, cj, caja)
    // if (code.startsWith('ca') || code.startsWith('cj') || code === 'caja') {
    //   return true;
    // }

    // // Verificar formatos numéricos (como "10" para CAJA_16)
    // if (!isNaN(Number(code))) {
    //   return true;
    // }

    // // Verificar que NO contenga UNID (formato de unidad)
    // if (code.includes('unid')) {
    //   return false;
    // }

    // // Por defecto, si no contiene UNID, asumir que es caja
    // return true;
  }

  calcularCajas(listado: any, formatoCodigo: string): number {
    if (this.esCaja(formatoCodigo, listado[0].formato_codigo_top)) {
      return this.calcularStockFormatoPrincipal(listado);
    }
    return 0;
  }

  calcularUnidades(listado: any, formatoCodigo: string): number {
    if (!this.esCaja(formatoCodigo, listado[0].formato_codigo_top)) {
      return this.calcularStockFormatoSecundario(listado);
    }
    return 0;
  }

  // Versiones que consideran el saldo
  // Caja/unidad se determinan por formato_codigo y formato_codigo_top, nunca por nombre_formato.
  // Excepción: Si formato_codigo es UNID pero nombre_formato es CA, tratarlo como caja.
  calcularCajasConSaldo(listado: any, formatoCodigo: string, saldo: number): number {
    if (!listado || listado.length === 0) {
      return 0;
    }
    if (saldo === 0 && listado.every(l => l.cantidad === 0)) {
      return 0;
    }
    const first = listado[0];
    if (!first) {
      return 0;
    }
    
    // Caso especial: Si formato_codigo es UNID pero nombre_formato es CA, tratarlo como caja
    if (first.formato_codigo && String(first.formato_codigo).toLowerCase() === 'unid' &&
        first.nombre_formato && String(first.nombre_formato).toUpperCase() === 'CA') {
      return this.calcularStockFormatoPrincipalBodega(listado);
    }
    
    const top = first.formato_codigo_top;
    // Un solo formato: solo es "caja" si formato_codigo_top no es UNID (esCaja usa formato_codigo_top)
    if (listado.length === 1) {
      return this.esCaja(formatoCodigo, top) ? this.calcularStockFormatoPrincipalBodega(listado) : 0;
    }
    if (this.esCaja(formatoCodigo, top)) {
      return this.calcularStockFormatoPrincipalBodega(listado);
    }
    return 0;
  }

  calcularUnidadesConSaldo(listado: any, formatoCodigo: string, saldo: number): number {
    if (saldo === 0) {
      return 0;
    }
    if (!listado || listado.length === 0) {
      return 0;
    }
    const firstItem = listado[0];
    if (!firstItem) {
      return 0;
    }
    
    // Caso especial: Si formato_codigo es UNID pero nombre_formato es CA, tratarlo como caja (unidades = 0)
    if (firstItem.formato_codigo && String(firstItem.formato_codigo).toLowerCase() === 'unid' &&
        firstItem.nombre_formato && String(firstItem.nombre_formato).toUpperCase() === 'CA') {
      return 0;
    }
    
    // Si el formato es caja (formato principal), retornar las unidades del formato secundario
    // Si el formato NO es caja (formato secundario como MED3), retornar la cantidad directamente (sin multiplicar)
    if (this.esCaja(formatoCodigo, firstItem.formato_codigo_top)) {
      // Es caja, calcular las unidades del formato secundario
      return this.calcularStockFormatoSecundarioBodega(listado);
    } else {
      // No es caja (es formato secundario como MED3), retornar la cantidad directamente (sin multiplicar por cantidad_formato)
      const formatoEncontrado = listado.find((item: any) => item.formato_codigo === formatoCodigo);
      if (formatoEncontrado) {
        return formatoEncontrado.cantidad; // Solo la cantidad, no cantidad * cantidad_formato
      }
      return 0;
    }
  }

  calcularStockFormatoPrincipal(listado: any) {
    // obtener formato principal
    let formatoPrincipal = this.obtenerFormatoPrincipal(listado);
    // existe formato principal
    if (formatoPrincipal) {
      let totalUnidadesInferiores = 0;
      for (var i = listado.length - 1; i > 0; i--) {
        totalUnidadesInferiores += listado[i].cantidad * listado[i].cantidad_formato;
      }

      // Evitar división por cero
      if (formatoPrincipal.cantidad_formato > 0) {
        return formatoPrincipal.cantidad + Math.floor(totalUnidadesInferiores / formatoPrincipal.cantidad_formato);
      } else {
        return formatoPrincipal.cantidad; // Retorna solo la cantidad sin dividir
      }

    }
    return 0;
  }

  calcularStockFormatoPrincipalBodega(listado: any) {
    const _formatoPrincipal = this.obtenerFormatoPrincipal(listado);
    const _listado = [...listado];

    if (_formatoPrincipal) {
      let _totalUnidadesInferiores = 0;
      // remover formato principal
      const listadoSinPrincipal = _listado.filter(f => f.formato_codigo !== _formatoPrincipal.formato_codigo);
      listadoSinPrincipal.forEach(item => {
        _totalUnidadesInferiores += item.cantidad * item.cantidad_formato;
      });

      return _formatoPrincipal.cantidad_formato > 0
        ? _formatoPrincipal.cantidad + Math.floor(_totalUnidadesInferiores / _formatoPrincipal.cantidad_formato)
        : 0;
    } else {
      return 0;
    }
  }

  calcularStockFormatoSecundario(listado: any) {
    const _formatoPrincipal = this.obtenerFormatoPrincipal(listado);
    const _formatoSecundario = this.obtenerFormatoSecundario(listado);
    const _listado = [...listado];

    if (_formatoPrincipal && _formatoSecundario) {
      let _totalUnidadesInferiores = 0;
      // remover formato principal
      const listadoSinPrincipal = _listado.filter(f => f.formato_codigo !== _formatoPrincipal.formato_codigo);
      listadoSinPrincipal.forEach(item => {
        _totalUnidadesInferiores += item.cantidad * item.cantidad_formato;
      });

      return ((_totalUnidadesInferiores % _formatoPrincipal.cantidad_formato) / _formatoSecundario.cantidad_formato) | 0;
    } else {
      return 0;
    }
  }

  calcularStockFormatoSecundarioBodega(listado: any) {
    if (!listado || listado.length === 0) {
      return 0;
    }

    const _formatoPrincipal = this.obtenerFormatoPrincipal(listado);
    if (!_formatoPrincipal) {
      return 0;
    }

    // Buscar el formato secundario en el listado
    // Primero intentar usar formato_secundario del formato principal
    let _formatoSecundario = null;
    if (_formatoPrincipal.formato_secundario) {
      _formatoSecundario = listado.find((item: any) =>
        item.formato_codigo === _formatoPrincipal.formato_secundario &&
        item.formato_codigo !== _formatoPrincipal.formato_codigo
      );
    }

    // Si no se encontró, buscar el primer formato que no sea el principal
    if (!_formatoSecundario && listado.length > 1) {
      _formatoSecundario = listado.find((item: any) =>
        item.formato_codigo !== _formatoPrincipal.formato_codigo
      );
    }

    if (_formatoPrincipal && _formatoSecundario) {
      // Crear copia del listado y remover el formato principal
      const listadoFiltrado = listado.filter(
        (f: any) => f.formato_codigo !== _formatoPrincipal.formato_codigo
      );

      let totalUnidadesInferiores = 0;
      for (const item of listadoFiltrado) {
        totalUnidadesInferiores += item.cantidad * item.cantidad_formato;
      }

      if (_formatoSecundario.cantidad_formato > 0 && _formatoPrincipal.cantidad_formato > 0) {
        return Math.floor(
          (totalUnidadesInferiores % _formatoPrincipal.cantidad_formato) /
          _formatoSecundario.cantidad_formato
        );
      }
    }

    return 0;
  }

  // Versiones que consideran el saldo para el resumen.
  // Caja/unidad por formato_codigo_top (nunca nombre_formato). UNID-only → Caja 0, Unidad = stock.
  // Excepción: Si formato_codigo es UNID pero nombre_formato es CA, tratarlo como caja.
  calcularStockFormatoPrincipalConSaldo(listado: any, saldo: number) {
    if (!listado || listado.length === 0) {
      return 0;
    }
    if (saldo === 0 && listado.every(l => l.cantidad === 0)) {
      return 0;
    }
    const first = listado[0];
    if (!first) {
      return 0;
    }
    
    // Caso especial: Si formato_codigo es UNID pero nombre_formato es CA, tratarlo como caja
    if (first.formato_codigo && String(first.formato_codigo).toLowerCase() === 'unid' &&
        first.nombre_formato && String(first.nombre_formato).toUpperCase() === 'CA') {
      return this.calcularStockFormatoPrincipal(listado);
    }
    
    const top = first.formato_codigo_top;
    // Si el formato principal es UNID, el stock debe ir a "Unidad/Fracción" y no a "Caja",
    // incluso si la lista trae más formatos (a veces vienen registros extra en 0).
    if (top && String(top).toLowerCase().includes('unid')) {
      return 0;
    }
    return this.calcularStockFormatoPrincipal(listado);
  }

  calcularStockFormatoSecundarioConSaldo(listado: any, saldo: number) {
    if (!listado || listado.length === 0) {
      return 0;
    }
    if (saldo === 0 && listado.every(l => l.cantidad === 0)) {
      return 0;
    }
    const first = listado[0];
    if (!first) {
      return 0;
    }
    
    // Caso especial: Si formato_codigo es UNID pero nombre_formato es CA, tratarlo como caja (fracción = 0)
    if (first.formato_codigo && String(first.formato_codigo).toLowerCase() === 'unid' &&
        first.nombre_formato && String(first.nombre_formato).toUpperCase() === 'CA') {
      return 0;
    }
    
    const top = first.formato_codigo_top;
    // Si el formato principal es UNID, el stock completo va como "Unidad/Fracción".
    if (top && String(top).toLowerCase().includes('unid')) {
      return this.calcularStockFormatoPrincipal(listado);
    }
    return this.calcularStockFormatoSecundario(listado);
  }


  calcularSaldoTotal(registros: any) {
    let saldoTotal = 0;
    registros.forEach(item => {
      saldoTotal += this.calcularStockFormatoPrincipalConSaldo(item.listaStockxUnidades, item.saldo);
    });
    return saldoTotal;
  }

  calcularSaldoTotalUnidad(registros: any) {
    let saldoTotal = 0;
    registros.forEach(item => {
      saldoTotal += this.calcularStockFormatoSecundarioConSaldo(item.listaStockxUnidades, item.saldo);
    });
    return saldoTotal;
  };

  calcularSaldoTotalXBodega(registros: any) {
    let saldoTotal = 0;
    registros.forEach(item => {
      // Usar calcularCajasConSaldo para que coincida con lo que se muestra en la tabla
      saldoTotal += this.calcularCajasConSaldo(item.listaStockxUnidadesxBodega, item.formato_codigo, item.saldo)
      // saldoTotal += this.calcularStockFormatoPrincipal(item.listaStockxUnidadesxBodega)
      // saldoTotal += this.calcularStockFormatoPrincipalConSaldo(item.listaStockxUnidadesxBodega, item.saldo)
      // saldoTotal += this.calcularStockSegunFormato(item.listaStockxUnidadesxBodega, item.formato_codigo)

    });
    return saldoTotal;
  };

  calcularSaldoTotalBodega(registros: any) {
    let saldoTotal = 0;
    registros.forEach(item => {
      saldoTotal += this.calcularStockFormatoPrincipalConSaldo(item.listaStockxUnidadesxBodega, item.saldo)
    });
    return saldoTotal;
  };

  calcularSaldoTotalXBodegaUnidad(registros: any) {
    // Agrupar por producto_codigo y formato_codigo para evitar duplicados cuando hay múltiples bodegas
    // Similar a como lo hace el resumen que agrupa por producto/formato
    const agrupados = registros.reduce((acc: any, item: any) => {
      const key = `${item.producto_codigo}_${item.formato_codigo}`;
      if (!acc[key]) {
        acc[key] = {
          producto_codigo: item.producto_codigo,
          formato_codigo: item.formato_codigo,
          unidades: 0
        };
      }
      // Calcular las unidades para este registro y sumarlas al total del grupo
      const unidadesRegistro = this.calcularUnidadesConSaldo(item.listaStockxUnidadesxBodega || [], item.formato_codigo, item.saldo || 0);
      acc[key].unidades += unidadesRegistro;
      return acc;
    }, {});

    // Sumar todas las unidades agrupadas
    let saldoTotal = 0;
    Object.values(agrupados).forEach((item: any) => {
      saldoTotal += item.unidades;
    });
    return saldoTotal;
  };

  calcularTotalTotal(registros: any) {
    let costoTotal = 0;
    registros.forEach(item => {
      //costoTotal += (this.calcularStockFormatoPrincipal(item.listaStockxUnidades) * item.costo_formato_principal)
      costoTotal += this.calcularCostoTodosLosFormatos(item.listaStockxUnidades, item.costo_formato_principal);
    });
    return costoTotal;
  };

  calcularTotalCostoFormatoPrincipalXBodega(registros: any) {
    let costoTotal = 0;
    registros.forEach(item => {
      const precioCostoFormatoPrincipal = this.obtenerPrecioCostoFormatoPrincipal(registros, item.formato_codigo, item.producto_codigo);
      costoTotal += this.calcularCostoTodosLosFormatos(item.listaStockxUnidadesxBodega, precioCostoFormatoPrincipal)
    });
    return costoTotal;
  };

  calcularTotalTotalXBodega(registros: any) {
    let costoTotal = 0;
    registros.forEach(item => {
      costoTotal += (this.calcularStockFormatoPrincipal(item.listaStockxUnidadesxBodega) * item.precio_ref)
    });
    return costoTotal;
  };

  groupProductsBySKU(registros: any) {

    var arregloAgrupado = [];

    registros.forEach((item) => {
      if (arregloAgrupado.filter(e => e.sku === item.sku).length === 0) {
        let _listBySku = registros.filter(e => e.sku === item.sku);
        let _newItem = {
          empresa_rut: item.empresa_rut,
          sucursal_codigo: item.sucursal_codigo,
          codigo: item.codigo,
          sku: item.sku,
          descripcion: item.descripcion,
          formato_codigo: item.formato_codigo,
          formato_nombre: item.formato_nombre,
          rubro_nombre: item.rubro_nombre,
          familia_nombre: item.familia_nombre,
          enero: 0,
          febrero: 0,
          marzo: 0,
          abrir: 0,
          mayo: 0,
          junio: 0,
          julio: 0,
          agosto: 0,
          septiembre: 0,
          octubre: 0,
          noviembre: 0,
          diciembre: 0,
          acumulado: 0,
        };
        _listBySku.forEach((i) => {
          _newItem.enero += i.enero > 0 ? i.enero : 0,
            _newItem.febrero += i.febrero > 0 ? i.febrero : 0,
            _newItem.marzo += i.marzo > 0 ? i.marzo : 0,
            _newItem.abrir += i.abrir > 0 ? i.abrir : 0,
            _newItem.mayo += i.mayo > 0 ? i.mayo : 0,
            _newItem.junio += i.junio > 0 ? i.junio : 0,
            _newItem.julio += i.julio > 0 ? i.julio : 0,
            _newItem.agosto += i.agosto > 0 ? i.agosto : 0,
            _newItem.septiembre += i.septiembre > 0 ? i.septiembre : 0,
            _newItem.octubre += i.octubre > 0 ? i.octubre : 0,
            _newItem.noviembre += i.noviembre > 0 ? i.noviembre : 0,
            _newItem.diciembre += i.diciembre > 0 ? i.diciembre : 0,
            _newItem.acumulado += i.acumulado > 0 ? i.acumulado : 0
        });
        arregloAgrupado.push(_newItem);
      }
    });
    return arregloAgrupado;
  }

  calcularCostoPorUnidad(listado: any, costo_formato_principal: number) {
    let _formatoPrincipal = this.obtenerFormatoPrincipal(listado);

    let _costoPorUnidad = _formatoPrincipal ? costo_formato_principal / _formatoPrincipal.cantidad_formato : 0;

    return _costoPorUnidad;
  }

  /** Misma semántica que `CalcularCostoPorUnidadBodega` en C# (Ultimate.Core Util). */
  calcularCostoPorUnidadBodega(listado: any, costo_formato_principal: number) {
    const formatoPrincipal = this.obtenerFormatoPrincipal(listado);
    if (!formatoPrincipal || !formatoPrincipal.cantidad_formato) {
      return 0;
    }
    return costo_formato_principal / formatoPrincipal.cantidad_formato;
  }

  calcularCostoTodosLosFormatos(listado: any, costo_formato_principal: number) {
    const stockFormatoPrincipal = this.calcularStockFormatoPrincipal(listado);
    const stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
    let _costoPorFormatoPrincipal = stockFormatoPrincipal * costo_formato_principal;
    // calculo segundo formato
    let _costoPorUnidad = Number(this.calcularCostoPorUnidad(listado, costo_formato_principal).toFixed(4));
    let _formatoSecundario = this.obtenerFormatoSecundario(listado);
    let _costoPorFraccion = _formatoSecundario ? _costoPorUnidad * (stockFormatoSecundario ? stockFormatoSecundario : 0) * _formatoSecundario.cantidad_formato : 0;

    let costoTotalProducto = _costoPorFormatoPrincipal + _costoPorFraccion;
    return Math.round(costoTotalProducto);
  };

  calcularCostoTodosLosFormatosSegunFormato(listado: any, costo_formato_principal: number, formato_codigo: string) {
    const stockFormatoPrincipal = this.calcularStockFormatoPrincipal(listado);
    const stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);

    // console.log('calcularCostoTodosLosFormatos', stockFormatoPrincipal, stockFormatoSecundario, costo_formato_principal);
    let _costoPorFormatoPrincipal = stockFormatoPrincipal * costo_formato_principal;
    // calculo segundo formato
    let _costoPorUnidad = this.calcularCostoPorUnidad(listado, costo_formato_principal);
    let _formatoSecundario = this.obtenerFormatoSecundario(listado);
    let _costoPorFraccion = _formatoSecundario ? Math.round(_costoPorUnidad * (stockFormatoSecundario ? stockFormatoSecundario : 0) * _formatoSecundario.cantidad_formato) : 0;

    if (formato_codigo && _formatoSecundario && formato_codigo === _formatoSecundario.formato_codigo) {
      // console.log('es fraccion', _costoPorFraccion)
      return _costoPorFraccion;
    } else {
      // console.log('es principal', _costoPorFormatoPrincipal)
      return _costoPorFormatoPrincipal;
    }

  };

  calcularCostoSegunFormato(listado: any, costo_formato_principal: number, formato_codigo: string) {
    if (listado.length === 0) {
      return 0;
    }
    if (listado.length === 1) {
      const stockFormatoPrincipal = this.calcularStockFormatoPrincipal(listado);
      const stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
      const costoPorFormatoPrincipal = stockFormatoPrincipal * costo_formato_principal;
      const costoPorFormatoSecundario = stockFormatoSecundario * costo_formato_principal;
      return costoPorFormatoPrincipal + costoPorFormatoSecundario;
    }
    if (listado.some(e => e.formato_codigo_top === formato_codigo)) { // es principal
      const stockFormatoPrincipal = this.calcularStockFormatoPrincipal(listado);
      const costoPorFormatoPrincipal = stockFormatoPrincipal * costo_formato_principal;
      return costoPorFormatoPrincipal;
    } else {
      const stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
      const costoPorFormatoSecundario = stockFormatoSecundario * costo_formato_principal;
      return costoPorFormatoSecundario;
    }
  }

  calcularStockSegunFormato(listado: any, formato_codigo: string) {
    if (listado.length === 0) {
      return 0;
    }
    if (listado.length === 1) {
      const stockFormatoPrincipal = this.calcularStockFormatoPrincipal(listado);
      const stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
      return stockFormatoPrincipal + stockFormatoSecundario;
    }
    if (listado.some(e => e.formato_codigo_top === formato_codigo)) { // es principal
      const stockFormatoPrincipal = this.calcularStockFormatoPrincipal(listado);
      return stockFormatoPrincipal;
    } else {
      const stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
      return stockFormatoSecundario;
    }
  }

  calcularMontoNetoTodosLosFormatos(listado: any, monto_neto_formato_principal: number) {
    let _montoNetoPorFormatoPrincipal = this.calcularStockFormatoPrincipal(listado) * monto_neto_formato_principal;
    // calculo segundo formato
    let _montoNetoPorUnidad = this.calcularCostoPorUnidad(listado, monto_neto_formato_principal);
    let _formatoSecundario = this.obtenerFormatoSecundario(listado);
    let _stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
    let _montoNetoPorFraccion = _formatoSecundario ? Math.round(_montoNetoPorUnidad * (_stockFormatoSecundario ? _stockFormatoSecundario : 0) * _formatoSecundario.cantidad_formato) : 0;

    return Math.floor(_montoNetoPorFormatoPrincipal + _montoNetoPorFraccion);
  };
  calcularDescuentoTodosLosFormatos(listado: any, descuento_formato_principal: number) {
    let _descuentoPorFormatoPrincipal = this.calcularStockFormatoPrincipal(listado) * descuento_formato_principal;
    // calculo segundo formato
    let _descuentoPorUnidad = this.calcularCostoPorUnidad(listado, descuento_formato_principal);
    let _formatoSecundario = this.obtenerFormatoSecundario(listado);
    let _stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
    let _descuentoPorFraccion = _formatoSecundario ? Math.round(_descuentoPorUnidad * (_stockFormatoSecundario ? _stockFormatoSecundario : 0) * _formatoSecundario.cantidad_formato) : 0;

    return Math.floor(_descuentoPorFormatoPrincipal + _descuentoPorFraccion);
  };
  calcularNetoTotalTodosLosFormatos(listado: any, neto_total_formato_principal: number) {
    let _netoTotalPorFormatoPrincipal = this.calcularStockFormatoPrincipal(listado) * neto_total_formato_principal;
    // calculo segundo formato
    let _netoTotalPorUnidad = this.calcularCostoPorUnidad(listado, neto_total_formato_principal);
    let _formatoSecundario = this.obtenerFormatoSecundario(listado);
    let _stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
    let _netoTotalPorFraccion = _formatoSecundario ? Math.round(_netoTotalPorUnidad * (_stockFormatoSecundario ? _stockFormatoSecundario : 0) * _formatoSecundario.cantidad_formato) : 0;

    return Math.floor(_netoTotalPorFormatoPrincipal + _netoTotalPorFraccion);
  };
  calcularPrecioRefTodosLosFormatos(listado: any, precio_ref_formato_principal: number) {
    let _precioRefPorFormatoPrincipal = this.calcularStockFormatoPrincipal(listado) * precio_ref_formato_principal;
    // calculo segundo formato
    let _precioRefPorUnidad = Number(this.calcularCostoPorUnidad(listado, precio_ref_formato_principal).toFixed(4));
    let _formatoSecundario = this.obtenerFormatoSecundario(listado);
    let _stockFormatoSecundario = this.calcularStockFormatoSecundario(listado);
    let _precioRefPorFraccion = _formatoSecundario ? _precioRefPorUnidad * (_stockFormatoSecundario ? _stockFormatoSecundario : 0) * _formatoSecundario.cantidad_formato : 0;

    let precioRefTotalProducto = _precioRefPorFormatoPrincipal + _precioRefPorFraccion;
    return Math.round(precioRefTotalProducto);
  };

  /**
   * Valor por fila alineado con Excel / `CalcularCostoTodosLosFormatosBodega` (lista por bodega).
   * El detalle de Stock valorizado y su pie deben usar esto, no `calcularPrecioRefTodosLosFormatos`.
   */
  calcularPrecioRefTodosLosFormatosBodega(
    listado: any,
    precio_ref_formato_principal: number,
    costo_formato_principal?: number | null
  ) {
    if (!listado || listado.length === 0) {
      return 0;
    }
    const costoPrincipal =
      costo_formato_principal != null && costo_formato_principal !== undefined && !Number.isNaN(Number(costo_formato_principal))
        ? Math.round(Number(costo_formato_principal))
        : Math.round(Number(precio_ref_formato_principal));
    const precioRefPorFormatoPrincipal = this.calcularStockFormatoPrincipalBodega(listado) * costoPrincipal;
    const precioRefPorUnidad = Number(this.calcularCostoPorUnidadBodega(listado, costoPrincipal).toFixed(4));
    const formatoSecundario = this.obtenerFormatoSecundario(listado);
    const stockFormatoSecundario = this.calcularStockFormatoSecundarioBodega(listado);
    const precioRefPorFraccion = formatoSecundario
      ? precioRefPorUnidad * (stockFormatoSecundario ? stockFormatoSecundario : 0) * formatoSecundario.cantidad_formato
      : 0;
    const precioRefTotalProducto = precioRefPorFormatoPrincipal + precioRefPorFraccion;
    return Math.round(precioRefTotalProducto);
  }

  calcularTotalTotalPrecioRefXBodega(registros: any) {
    let costoTotal = 0;
    registros.forEach(item => {
      costoTotal += this.calcularPrecioRefTodosLosFormatosBodega(
        item.listaStockxUnidadesxBodega,
        item.precio_ref,
        item.costo_formato_principal
      );
    });
    return costoTotal;
  };

  calcularTotalTotalPrecioRef(registros: any) {
    let costoTotal = 0;
    registros.forEach(item => {
      costoTotal += this.calcularPrecioRefTodosLosFormatos(item.listaStockxUnidades, item.precio_ref);
      // costoTotal += this.calcularCostoTodosLosFormatos(item.listaStockxUnidades, item.precio_ref);
    });
    return costoTotal;
  };

  obtenerPrecioCostoFormatoPrincipal(registro: any[], formato_codigo: string, producto_codigo: string) {
    const formatoPrincipal = registro.find(x => x.producto_codigo === producto_codigo && x.listaStockxUnidadesxBodega
      .some(y => y.formato_codigo_top === formato_codigo || y.formato_secundario === formato_codigo));

    const costoTotalFormatoPrincipal = formatoPrincipal ? formatoPrincipal.costo_formato_principal : 0;
    return costoTotalFormatoPrincipal;
  }
}
